import React, { useContext, useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";

import AutoCompleteDropdown from "../../../../../Base/Components/Form/AutoCompleteDropdown";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { useForm } from "../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../Base/Services/ToastService";

import { getPersonal } from "../../../../../API/RRHH/Personal/PersonalRequests";
import { editarExtension, guardarExtension } from "../../../../../API/IT/Dispositivos/DispositivosRequest";

const ExtensionesCRUD = ({ showDialog, setShowDialog, getInfo, selected, setSelected }) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [loading, setLoading] = useState(false);
  const [personal, setPersonal] = useState([]);

  const initialValues = {
    IdExtension: -1,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    const personalTempo = await getPersonal()
    setPersonal(personalTempo);
    if(selected[0]?.IdExtension){
      setValues({
        ...selected[0],
      })
    }
    setLoading(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values?.Extension) {
      error.Extension = true;
      error.error = true;
    }
    if(!values?.NombreCompletoPrimer?.IdPersonal  && !values?.IdPersonal){
      error.IdPersonal = true;
      error.error = true;
    }
    setError(error);
    return error;
  };


  const agregar = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const Datos = {
        IdExtension: values?.IdExtension,
        Extension: values?.Extension,
        IdPersonal: values?.NombreCompletoPrimer?.IdPersonal || values?.IdPersonal,
        Comentario: values?.Comentario,
        IdUserCreate: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser
      };

      setLoading(true);
      if (Datos?.IdExtension > 0) {
        const resultado = await editarExtension(Datos);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(toast, "success", "Datos Editados", resultado[0]?.MENSAJE);
          getInfo();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toast, "error", "Error al Editar", resultado[0]?.MENSAJE);
          setLoading(false);
        }
      } else {
        const resultado = await guardarExtension(Datos);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(toast, "success", "Datos Agregados", resultado[0]?.MENSAJE);
          getInfo();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toast, "error", "Error al agregar", resultado[0]?.MENSAJE);
          setLoading(false);
        }
      }
    }
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
    setError({});
    setSelected([]);
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={selected[0]?.IdExtension > 0 ? "Editar" : "Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregar();
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = selected[0]?.IdExtension > 0 ? "Editar Extensión" : "Agregar Extensión";

  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
        style={{ width: "40%" }}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ margin: "auto" }}>
            <Toast ref={toast} style={{ zIndex: 50000 }} />

            <div className="d-flex mx-2 gap-2 mt-4">
              <div className="field col-6">
                <span className="p-float-label">
                  <InputText
                    name="Extension"
                    value={values?.Extension}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Extension ? "p-invalid" : ""}
                  />
                  <label htmlFor="Extension">Extensión</label>
                </span>
              </div>

              <div className="field col-6">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"NombreCompletoPrimer"}
                    value={values?.NombreCompletoPrimer}
                    items={personal}
                    field={"NombreCompletoPrimer"}
                    label={"Personal"}
                    handleInputChange={handleInputChange}
                    className={error.IdPersonal ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="d-flex mx-2 gap-2 mt-4">
              <div className="field col-12">
                <span className="p-float-label">
                  <InputText
                    name="Comentario"
                    value={values?.Comentario}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Comentario ? "p-invalid" : ""}
                  />
                  <label htmlFor="Comentario">Comentario</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default ExtensionesCRUD;
